import { render, staticRenderFns } from "./MyInvigilateHistory.vue?vue&type=template&id=15157c40&scoped=true&"
import script from "./MyInvigilateHistory.vue?vue&type=script&lang=js&"
export * from "./MyInvigilateHistory.vue?vue&type=script&lang=js&"
import style0 from "./MyInvigilateHistory.vue?vue&type=style&index=0&id=15157c40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15157c40",
  null
  
)

export default component.exports